import BaseOption from "%/dynamic-component-editor/classes/base-option";
import { inspectorTools } from "%/dynamic-component-editor/inspector/inspector-tool-map";

export default class ButtonSize extends BaseOption {
  static userInterfaceComponent = {
    label: "Size",
    component: inspectorTools.SIMPLE_PICKER,
    props: {
      options: [
        {
          id: "small",
          name: "Small",
        },
        {
          id: "standard",
          name: "Standard",
        },
        {
          id: "large",
          name: "Large",
        },
      ],
    },
  };

  static defaultValue = "standard";

  static convertConfigValueToCompiledValue(configValue) {
    if (configValue === "extraSmall") {
      return "small";
    }
    return configValue;
  }
}
